/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

import { cssPath } from './selector';

export class DOM {
  public static uid(): string {
    let id = '';

    do {
      id += Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '');
    } while (id.length < 8);

    return id.substr(0, 8);
  }

  public static addEventListener(elm: any, event: string, listener: (ev: Event) => any): void {
    if (elm.addEventListener) {
      elm.addEventListener(event, listener, false);
    } else {
      elm.attachEvent(`on${event}`, () => {
        // set the this pointer same as addEventListener when fn is called
        return listener.call(elm, window.event as Event);
      });
    }
  }

  public static getSelector(elm: any): string {
    return cssPath(elm, true);
  }
}
